//#region Libraries
import { useEffect } from "react";
//#endregion
//#region Services
import { eventsSessionStorage } from "services/storage/events";
//#endregion
//#region Utils
import usePrevious from "utils/hooks/usePrevious";
import { EVENTS_CONSTANTS } from "config/constants";
//#endregion

const { EVENT_PERIOD_IDS } = EVENTS_CONSTANTS;

const useObserveEventTypeId = ({
	eventTypeId,
	eventSubtypeId,
	changeEventSubtypeId,
	changeEventGraphicId,
	changeComplementaryServiceAreaId,
	changePayGradeField,
	changePeriod,
	eventResumeData,
	areNotEventSubtypes,
	areNotSectionSubtype,
	changeSectionSubtypeId,
}) => {
	const prevEventTypeId = usePrevious(eventTypeId);
	//#region Effects
	useEffect(() => {
		observe();
	}, [eventTypeId, eventSubtypeId]);
	//#endregion
	//#region Functions
	function observe() {
		if (areNotEventSubtypes()) {
			changeEventSubtypeId(0);
			resetDependentFieldsWhenChangeEventTypeId();
		}
		if(areNotSectionSubtype()){
			changeSectionSubtypeId(0);
		}
		if (resetPeriodWhenEventTypeId()) return;
		if (
			(prevEventTypeId || (prevEventTypeId === 0 && eventTypeId > 0)) &&
			eventTypeId !== 1
		)
			changePeriod(EVENT_PERIOD_IDS.ONLY_DAY);
	}
	function resetPeriodWhenEventTypeId() {
		const changedEventTypeToWorkshop = prevEventTypeId && eventTypeId === 1;
		if (!changedEventTypeToWorkshop) return false;
		if (!eventResumeData || eventsSessionStorage.isDraftEvent.get()) {
			changePeriod(EVENT_PERIOD_IDS.EMPTY);
			return true;
		}
		changePeriod(
			eventResumeData.step1.duration.period || EVENT_PERIOD_IDS.EMPTY
		);
		return true;
	}
	function resetDependentFieldsWhenChangeEventTypeId() {
		const changedEventType = prevEventTypeId && eventTypeId > 0;
		if (!changedEventType) return;
		changeComplementaryServiceAreaId(0);
		changeEventGraphicId(0);
		changePayGradeField(0);
	}
	//#endregion
};

export default useObserveEventTypeId;
